export const rootStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '16px',
  marginBottom: '16px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.divider}`,
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const sessionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const sessionHeaderStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '12px',
  flexWrap: 'wrap',
};

export const sessionActionsStyles = {
  display: 'flex',
  gap: '8px',
};

export const buttonContentStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};
